import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AuthenticationActions } from 'src/app/shared/authentication/action-types';
import { UserAction } from '../../../action-types';

@Component({
    selector: 'app-user-loaded-fail-dialog',
    templateUrl: './user-loaded-fail-dialog.component.html',
    styleUrls: ['./user-loaded-fail-dialog.component.scss'],
    standalone: false
})
export class UserLoadedFailDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<UserLoadedFailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public errorMessage: string,
    private readonly store: Store) { }

  ngOnInit(): void {
  }

  onRetryClick() {
    this.store.dispatch(UserAction.loadUser())
  }

  onLogoutClick() {
    this.store.dispatch(AuthenticationActions.signOut())
  }

}
